// Copyright ©️ 2026 eVolve MEP, LLC

import { EditCustomPropertiesModal } from 'components/Mantine/CustomProperties/EditCustomPropertiesModal';

type Props = {
  keepMounted: boolean;
  disabled?: boolean;
  opened: boolean;
  onClose: () => void;
};

/**
 * Wrapper around `EditCustomPropertes` for use in the modal registry.
 * Makes `opened`, `onClose` and `keepMounted` required and specifies the `customPropertyTypeName`.
 **/
export const ManageBendCustomPropertiesModal = (props: Props) => (
  <EditCustomPropertiesModal customPropertyTypeName="Fabrication Item" {...props} />
);
